import { TextInput } from "@msuite/ui/form";
import type { SearchForm } from "@msuite/ui/hooks";

/** Props Interface */
interface SubstitutionPlanSummaryFilterProps {
	searchForm: SearchForm;
}

export function SubstitutionPlanSummaryFilter({ searchForm }: SubstitutionPlanSummaryFilterProps) {
	return (
		<div className="h-stack">
			<div {...searchForm.getSearchInputWrapperProps()}>
				<TextInput {...searchForm.getSearchInputProps()} />
			</div>
		</div>
	);
}
